import { ListItem } from "@src/types/ota-update";
import apiUseCases from "../../api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
export interface GetBackupsResult {
  success: boolean;
  data?: ListItem[];
  error?: string;
}

export const getBackupsUseCase = async (): Promise<GetBackupsResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const sourceId = store.getState().yourSlice.connectionView.source.source_id;
    const response = await apiUseCases.getBackups(namespace, sourceId);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch backups").message,
    };
  }
};
